import { fetchEarningsConfig, save, fetchEarningsConfigsPaginated, fetchAllEarningsConfigs } from "../services/earnings.services"
import { actions as earningsActions } from "../store/earnings.store";
import { store } from "../../../redux";
import { EARNINGS_STORE_NAME } from "../../../contants/stores";
import { EarningConfig } from "../types/earning.data";

export const getEarnings = async () => {
  const query = await fetchEarningsConfig();
  const data = query.data();
  store.dispatch(earningsActions.setEarningConfigs(data));
  store.dispatch(earningsActions.setDefaultEarningConfig(data));
  // Also set total count for display
  if (data && data.configs) {
    store.dispatch(earningsActions.setTotalCount(data.configs.length));
  }
}

export const deleteEarningConfig = async (title: string) => {
  let configs = [...store.getState()[EARNINGS_STORE_NAME].earningConfigs.filter((c: EarningConfig) => c.title !== title)];
  await save(configs)
  store.dispatch(earningsActions.updateEarningConfigs(configs));
}

export const updateEarningConfigs = async (config: EarningConfig, originalTitle?: string) => {
  let configs = [...store.getState()[EARNINGS_STORE_NAME].earningConfigs];

  // Use originalTitle if provided (for edits where title might have changed), otherwise use config.title
  const titleToFind = originalTitle || config.title;
  const updateIndex = configs.findIndex((c: EarningConfig) => c.title === titleToFind);
  
  if(updateIndex > -1) {
    // Update existing config
    configs.splice(updateIndex, 1, {
      ...config,
    });
  } else {
    // Add new config
    configs.push({...config})
  }
  await save(configs)
  store.dispatch(earningsActions.updateEarningConfigs(configs));
}



export const updateQuery = (query: string) => {
  store.dispatch(earningsActions.updateSearchQuery(query));
}

export function search(query: string) {
  const allConfigs = store.getState()[EARNINGS_STORE_NAME].allEarningConfigs;
  return allConfigs.filter((item: any) => {
    return (
      item.title.toLowerCase().includes(query.toLowerCase())
    );
  });
}

export const getAllEarningsConfigs = async (limit: number, offset: number) => {
  try {
    const result = await fetchEarningsConfigsPaginated(limit, offset);
    store.dispatch(earningsActions.updateEarningConfigs(result.configs));
    store.dispatch(earningsActions.setTotalCount(result.totalCount));
  } catch (error) {
    console.log("getAllEarningsConfigs error:", error);
  }
}

export const getAllEarningsConfigsForSearch = async () => {
  try {
    const allConfigs = await fetchAllEarningsConfigs();
    store.dispatch(earningsActions.setAllConfigs(allConfigs));
  } catch (error) {
    console.log("getAllEarningsConfigsForSearch error:", error);
  }
}

export const setCurrentPage = (page: number) => {
  store.dispatch(earningsActions.setCurrentPage(page));
}

export const setRowsPerPage = (rows: number) => {
  store.dispatch(earningsActions.setRowsPerPage(rows));
}